import React from 'react';
import { MdAdd, MdEdit, MdSwapHoriz, MdSearch, MdVisibility } from 'react-icons/md';
import ReactPaginate from 'react-paginate';
import TableLoadingWrapper from './TableLoadingWrapper';
import '../styles/views.css';

const TransactionsView = ({
  pagedFilteredData,
  searchTerm,
  setSearchTerm,
  pageCount,
  handlePageClick,
  setIsAddModalOpen,
  setEditTransaction,
  setIsEditModalOpen,
  loading,
}) => {
  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'successful':
      case 'success':
      case 'completed':
        return { bg: '#e8f5e8', color: '#2e7d32' };
      case 'failed':
      case 'error':
      case 'declined':
        return { bg: '#ffebee', color: '#c62828' };
      case 'pending':
      case 'processing':
        return { bg: '#fff3cd', color: '#856404' };
      default:
        return { bg: '#f5f5f5', color: '#666' };
    }
  };

  return (
    <>
      {/* Header Section */}
      <div style={{
        marginBottom: 24,
        padding: '20px 24px',
        backgroundColor: '#fff',
        borderRadius: 12,
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        border: '1px solid #f0f0f0'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: 16
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <MdSwapHoriz size={24} style={{ color: '#1976d2' }} />
            <h3 style={{ margin: 0, color: '#333', fontSize: 18, fontWeight: '600' }}>
              Transaction History
            </h3>
          </div>
        </div>

        {/* Search Controls */}
        <div style={{ position: 'relative', maxWidth: 400 }}>
          <MdSearch size={20} style={{
            position: 'absolute',
            left: 12,
            top: '50%',
            transform: 'translateY(-50%)',
            color: '#666'
          }} />
          <input
            type="text"
            placeholder="Search transactions by amount, status, or reference..."
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
            style={{
              width: '100%',
              padding: '10px 12px 10px 40px',
              borderRadius: 8,
              border: '1px solid #ddd',
              fontSize: 14,
              outline: 'none',
              transition: 'border-color 0.2s ease',
              boxSizing: 'border-box'
            }}
            onFocus={e => e.target.style.borderColor = '#1976d2'}
            onBlur={e => e.target.style.borderColor = '#ddd'}
          />
        </div>
      </div>
      <TableLoadingWrapper loading={loading}>
        <div style={{ marginBottom: 24, boxShadow: '0 2px 8px rgba(0,0,0,0.1)', borderRadius: 8, backgroundColor: '#fff',
          scrollbarWidth: 'thin',
          scrollbarColor: '#1976d2 #e0e0e0',
          maxWidth: 'calc(100% - 20px)',
          marginLeft: 'auto',
          marginRight: 'auto',
        }}>

          <table>
            <thead>
              <tr>
                <th>Amount</th>
                <th>Status</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {pagedFilteredData.map((row, i) => (
                <tr key={i} style={{ cursor: 'default' }}>
                  <td>{row.amount}</td>
                  <td>{row.status}</td>
                  <td>{row.created_at}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </TableLoadingWrapper>
      {pageCount > 1 && (
        <ReactPaginate
          previousLabel={'previous'}
          nextLabel={'next'}
          breakLabel={'...'}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={handlePageClick}
          containerClassName={'pagination'}
          activeClassName={'active'}
        />
      )}
    </>
  );
};

export default TransactionsView;